<res-base-modal [modalTitle]="modalTitle" [modalAutomationId]="modalAutomationId" (closeButtonActionEmt)="closeModal()"
    [primaryButtonLabel]="primaryButtonLabel" (primaryButtonActionEmt)="ok()"
    [secondaryButtonLabel]="secondaryButtonLabel" [modalHelpIndex]="modalHelpIndex" [modalClass]="modalClass"
    [modalDraggable]=false [isPrimaryBtnEnabled]="isPrimaryButtonEnabled()">
    <res-generic-grid [gridName]="gridName" [automationId]="modalAutomationId" [(isBusy)]="isBusy"
        [(isBusyMessage)]="isBusyMessage" [columnDefs]="columnDefs" [pagerVisible]="false" [gridContext]="gridContext"
        [rowSelection]="rowSelection">
    </res-generic-grid>
</res-base-modal>